import React from "react";
import { AxiosResponse } from "axios";
import { makeStyles, Theme } from "@material-ui/core/styles";
import CustomAlert from "../../components/Alert/CustomAlert";
import TestRequestApi from "../../api/services/TestRequestApi";
import FileUpload from "./FileUpload";
import useEnv from "../../hooks/env";

const useStyles = makeStyles((theme: Theme) => ({
  marginBottom5: {
    marginBottom: theme.spacing(5),
  },
  subHeading: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(1),
  },
}));

const ACCEPTED_FILES = {
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};
const MAX_FILE_SIZE_MB = 5;
const SUCCESS_MESSAGE = "Successfully updated user mapping";

const UserAssignmentUpload: React.FC = () => {
  const classes = useStyles();
  const { api } = useEnv();
  const testRequestApi = new TestRequestApi(api);

  const handleUpload = (
    payload: FormData,
    progressCallback?: (progressEvent: { loaded: number; total: number }) => void,
  ): Promise<AxiosResponse> => {
    return testRequestApi.updateUserMapping(payload, progressCallback);
  };

  return (
    <div className={classes.marginBottom5}>
      <div className={classes.subHeading}>Update CSC-User Lab Assignment</div>
      <CustomAlert
        severity="info"
        className={classes.marginBottom5}
        text="
          Uploading a new User-Excel directly updates all laboratory assignments
          for CSC users. Users who are not present in the excel will lose their
          lab assignment.
      "
      />
      <FileUpload
        acceptedFiles={ACCEPTED_FILES}
        buttonLabel="Update Lab Assignment"
        maxFileSizeMB={MAX_FILE_SIZE_MB}
        successMessage={SUCCESS_MESSAGE}
        upload={handleUpload}
      />
    </div>
  );
};

export default UserAssignmentUpload;
